export default __webpack_public_path__ + "static/media/658.6f41ae23.png";